'use strict';

var React = require('react');

var SvgCashPoundMajor = function SvgCashPoundMajor(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M20 10c0 5.523-4.477 10-10 10s-10-4.477-10-10 4.477-10 10-10 10 4.477 10 10zm-12.217 1h-.244a.997.997 0 0 1-1-1 1.003 1.003 0 0 1 1-1h.472c.018-.34.028-.682.028-1.027 0-1.893 1.057-3.246 2.555-3.483 1.504-.239 2.867.785 2.867 2.4a1 1 0 1 1-2 0c0-.323-.21-.48-.555-.425-.487.077-.867.563-.867 1.508 0 .345-.009.687-.026 1.027h1.526a1.003 1.003 0 0 1 1 1 1 1 0 0 1-1 1h-1.73a18.65 18.65 0 0 1-.422 2h2.652a1.003 1.003 0 0 1 1 1 1 1 0 0 1-1 1h-4a.997.997 0 0 1-1-1 .994.994 0 0 1 .056-.354c.302-.86.53-1.742.688-2.646z"
  }));
};

exports.SvgCashPoundMajor = SvgCashPoundMajor;
